module.exports = __webpack_public_path__ + "img/banner.87e15d4d.png";